export default __webpack_public_path__ + "static/media/Arrow-down.6034d1b9.svg";